import React, { createContext, useContext, useState, ReactNode } from 'react';
import dayjs, { Dayjs } from 'dayjs';

type DateRangeType = [Dayjs | null, Dayjs | null];

interface DashboardFilterContextType {
  contentType: string[];
  setContentType: (type: string[]) => void;
  competition: string[];
  setCompetition: (comp: string[]) => void;
  season: string[];
  setSeason: (season: string[]) => void;
  dateRange: DateRangeType;
  setDateRange: (range: DateRangeType) => void;
  updateDashboard: number;
  setUpdateDashboard: (value: number) => void;
  filterLoaded: boolean; 
  setFilterLoaded: (value: boolean) => void;
}

const DashboardFilterContext = createContext<DashboardFilterContextType | undefined>(undefined);

export const DashboardFilterProvider = ({ children }: { children: ReactNode }) => {
  // Inizializziamo i filtri
  const [contentType, setContentType] = useState<string[]>(['All']);
  const [competition, setCompetition] = useState<string[]>(['All']);
  const [season, setSeason] = useState<string[]>(['All']);
  const [dateRange, setDateRange] = useState<DateRangeType>([
    dayjs().subtract(1, 'month'),
    dayjs()
  ]);
  const [filterLoaded, setFilterLoaded] = useState(false);
  const [updateDashboard, setUpdateDashboard] = useState<number>(0);

  return (
    <DashboardFilterContext.Provider value={{
      contentType, setContentType,
      competition, setCompetition,
      season, setSeason,
      dateRange, setDateRange,
      updateDashboard, setUpdateDashboard,
      filterLoaded, setFilterLoaded
    }}>
      {children}
    </DashboardFilterContext.Provider>
  );
};

export const useDashboardFilters = () => {
  const context = useContext(DashboardFilterContext);
  if (!context) {
    throw new Error('useDashboardFilters deve essere usato all\'interno di un DashboardFilterProvider');
  }
  return context;
};